"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withConfig = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var use_config_1 = require("./use-config");
function withConfig(WrappedComponent) {
    return react_1.default.forwardRef(function (props, ref) {
        var config = (0, use_config_1.useConfig)();
        return react_1.default.createElement(WrappedComponent, (0, tslib_1.__assign)((0, tslib_1.__assign)({}, props), { ref: ref, config: config }));
    });
}
exports.withConfig = withConfig;
